import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Trockenbau = () => {
  const pageData = {
    title: 'TROCKENBAU',
    subtitle: 'Flexible Raumgestaltung',
    description: 'Moderne Trockenbau-Lösungen für flexible Raumgestaltung. Von Trennwänden bis zu abgehängten Decken.',
    heroImage: 'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/je9ovspj_WhatsApp%20Image%202026-05-01%20at%2010.45.51%20%282%29.jpeg',
    features: [
      { title: 'Trennwände', description: 'Nicht-tragende Wände für flexible Raumaufteilung.' },
      { title: 'Decken', description: 'Abgehängte Decken für bessere Raumakustik.' },
      { title: 'Vorsatzschalen', description: 'Dämmung und Verkleidung von Außenwänden.' },
      { title: 'Brandschutz', description: 'Brandschutzwände und -decken nach Norm.' },
      { title: 'Schallschutz', description: 'Lärmdämmende Konstruktionen.' },
      { title: 'Lichtkuppeln', description: 'Integration von Lichtlösungen in Decken.' }
    ],
    benefits: [
      'Schnelle und saubere Bauweise',
      'Flexible Raumgestaltung',
      'Gute Dämmeigenschaften',
      'Leichte Nachbearbeitung möglich',
      'Integrierbare Haustechnik',
      'Kosteneffizient'
    ],
    process: [
      { title: 'Planung', description: 'Raumkonzept und Statikprüfung.' },
      { title: 'Montage', description: 'Aufbau der Unterkonstruktion.' },
      { title: 'Beplankung', description: 'Anbringen der Gipskartonplatten.' },
      { title: 'Verspachtelung', description: 'Fugen verspachteln und glätten.' }
    ],
    gallery: [
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/onohyyqc_WhatsApp%20Image%202026-05-01%20at%2010.45.52.jpeg',
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/l8dt6d5f_WhatsApp%20Image%202026-05-01%20at%2010.45.52.jpeg',
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/8rrlb99p_WhatsApp%20Image%202026-05-01%20at%2010.45.52%20%286%29.jpeg'
    ],
    metaKeywords: 'Trockenbau Graubünden, Gipskarton Cazis, Trennwände, Abgehängte Decken'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Trockenbau;